import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-black tracking-tight text-background-50">911</span>
              <span className="text-sm font-medium text-background-50/60 ml-1">爆料网</span>
            </Link>
            <p className="text-sm text-background-50/50 leading-relaxed">
              第一时间放出猛料，网红反差视频、博主私下爆料、明星聊天记录泄露，911爆料网与你一起吃瓜。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">订阅猛料</h4>
            <form
              data-readdy-form
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col gap-3"
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱订阅最新爆料"
                  className="w-full bg-transparent border-0 border-b border-background-50/20 pb-2 text-sm text-background-50 placeholder:text-background-50/30 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-0 bottom-2 w-6 h-6 flex items-center justify-center text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                  aria-label="订阅"
                >
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </div>
              <p className="text-xs text-background-50/30">
                订阅即表示同意我们的
                <Link to="/about" className="text-background-50/50 hover:text-primary-400 transition-colors">隐私政策</Link>
              </p>
            </form>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">快速链接</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/wanghong-heiliao" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">网红黑料</Link>
              <Link to="/category/mingxing-liaotian" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">明星聊天记录</Link>
              <Link to="/category/bozhu-baoliao" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">博主私下爆料</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-5">关注我们</h4>
            <div className="flex flex-col gap-3">
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-weibo-line text-base"></i> 微博
              </a>
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-wechat-line text-base"></i> 微信公众号
              </a>
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-telegram-line text-base"></i> Telegram频道
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-6 lg:px-10 pb-10">
        <div className="text-[8rem] md:text-[12rem] lg:text-[16rem] font-black tracking-[-0.08em] leading-none text-background-50/8 select-none">
          911
        </div>
      </div>

      <div className="border-t border-background-50/8">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-50/30">
            &copy; {currentYear} 911爆料网. All rights reserved.
          </p>
          <p className="text-xs text-background-50/30">
            本站内容仅供娱乐，不构成任何投资或法律建议
          </p>
        </div>
      </div>
    </footer>
  );
}